import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_MIVO_LOCALE } from "./ITranslation";
import { resolveInitialLocale } from "./localeStorage";

const resources = {
  "pt-BR": { translation: {} },
  en: { translation: {} },
  es: { translation: {} },
  de: { translation: {} },
};

const initialLocale = resolveInitialLocale();

void i18next.use(initReactI18next).init({
  resources,
  lng: initialLocale,
  fallbackLng: DEFAULT_MIVO_LOCALE,
  defaultNS: "translation",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
